import React, { useEffect, useState } from 'react';
import { Modal, Button, Form } from 'react-bootstrap';
import { CompanyService } from '../CompanyService';
import { ErrorToast } from '../../../utils/toasters';

interface ICreateGroupModal {
    show: boolean;
    clientId: number;
    clientName: string;
    onHide: () => void;
    onCreated: (group: any) => void;
}

const initialForm = { name: '', nameDe: '', supplierId: '', isMultiple: false };

export function CreateGroupModal({ show, clientId, clientName, onHide, onCreated }: ICreateGroupModal) {
    const [form, setForm] = useState(initialForm);
    const [suppliers, setSuppliers] = useState<{ id: number; displayName: string }[]>([]);

    useEffect(() => {
        if (show) {
            CompanyService.getClientSuppliers(clientId)
                .then(data => setSuppliers(data.data ?? data))
                .catch(err => ErrorToast(err));
        }
    }, [show]);

    const handleChange = (e: React.ChangeEvent<HTMLInputElement>) => {
        const { name, value, type, checked } = e.target;
        setForm(prev => ({ ...prev, [name]: type === 'checkbox' ? checked : value }));
    };

    const handleSubmit = () => {
        const body = {
            name: form.name,
            ...(form.nameDe && { nameDe: form.nameDe }),
            ...(form.supplierId && { supplierId: Number(form.supplierId) }),
            isMultiple: form.isMultiple,
        };
        CompanyService.createGroup(clientId, body)
            .then(data => {
                onCreated(data);
                setForm(initialForm);
                onHide();
            })
            .catch(err => ErrorToast(err));
    };

    return (
        <Modal show={show} onHide={onHide} centered>
            <Modal.Header closeButton>
                <Modal.Title>Create group for {clientName}</Modal.Title>
            </Modal.Header>
            <Modal.Body>
                <Form.Group className="mb-3">
                    <Form.Label>
                        Name EN <span className="text-danger">*</span>
                    </Form.Label>
                    <Form.Control name="name" value={form.name} onChange={handleChange} />
                </Form.Group>
                <Form.Group className="mb-3">
                    <Form.Label>
                        Name DE <span className="text-danger">*</span>
                    </Form.Label>
                    <Form.Control name="nameDe" value={form.nameDe} onChange={handleChange} />
                </Form.Group>
                <Form.Group className="mb-3">
                    <Form.Label>Supplier</Form.Label>
                    <Form.Select
                        name="supplierId"
                        value={form.supplierId}
                        onChange={e => setForm(prev => ({ ...prev, supplierId: e.target.value }))}
                    >
                        <option value="">— None —</option>
                        {suppliers.map(s => (
                            <option key={s.id} value={s.id}>
                                {s.displayName}
                            </option>
                        ))}
                    </Form.Select>
                </Form.Group>
                <Form.Check
                    type="checkbox"
                    name="isMultiple"
                    label="Multiple select"
                    checked={form.isMultiple}
                    onChange={handleChange}
                />
            </Modal.Body>
            <Modal.Footer>
                <Button variant="outline-primary" onClick={onHide}>
                    Cancel
                </Button>
                <Button variant="primary" onClick={handleSubmit} disabled={!form.name}>
                    Create
                </Button>
            </Modal.Footer>
        </Modal>
    );
}
